<template>
  <div class="room">
    <el-checkbox class="room__checkbox" v-model="roomSelected"/>
    <span class="room__label" :class="{bold: nb > 0}" @click="selectRoom" >{{ roomName }}</span>
    <input-number
      class="room__input-number"
      :class="{hidden: nb === 0}"
      v-model="nb"
      :height="26"
      :min="0"
      :step="1"
      @change="updateRoomNumber"/>
  </div>
</template>

<script>
import InputNumber from '@/components/utils/InputNumber.vue';

export default {
  name: 'room',
  components: {
    InputNumber,
  },
  props: {
    roomName: {
      type: String,
    },
    nb: {
      type: Number,
    },
  },
  computed: {
    roomSelected: {
      get() {
        return this.nb !== undefined && this.nb !== 0;
      },
      set(value) {
        if (this.nb === 0 || this.nb === 1) this.$emit('update:nb', value ? 1 : 0);
      },
    },
  },
  methods: {
    updateRoomNumber(nb) {
      this.$emit('update:nb', nb);
    },
    selectRoom() {
      if (this.nb === 0) this.$emit('update:nb', 1);
    },
  },
};
</script>

<style scoped lang="scss">
  .room {
    user-select: none;
    display: flex;
    grid-template-columns: auto 50% auto;
    margin: .3em 0;
    &__checkbox {
      flex-shrink: 1;
      padding-right: 10px;
    }
    &__label {
      flex-grow: 2;
      width: 100%;
      text-align: start;
      padding-left: 4px;
      font-size: 16px;
      cursor: pointer;

      word-break: break-word;
    }
    &__input-number {

    }
  }
  .hidden {
    visibility: hidden;
  }

  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: $--color-secondary;
    border-color: $--color-secondary;
  }
  ::v-deep .el-checkbox__inner {
    width: 26px;
    height: 26px;
    border-radius: $--border-radius-base;
    background: $--color-light-grey-blue;
  }
  ::v-deep .el-checkbox__inner:hover {
    border-color: $--color-secondary;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after{
    transform: rotate(45deg) scaleY(1.5);
    left: 10px;
    top: 6px;
    border-width: 0 3px 3px 0;
  }
</style>
